import { InformationPipe } from '../pipes/content/information.pipe';
import { NewsPipe } from '../pipes/content/news.pipe';
import { TransportPipe } from '../pipes/content/transport.pipe';
import { WebcamPipe } from '../pipes/content/webcam.pipe';
import { WeatherPipe } from '../pipes/content/weather.pipe';
import { TemperaturePipe } from '../pipes/content/temperature.pipe';
import { MountainRailwayPipe } from '../pipes/content/mountain-railway.pipe';
import { AlphabetPipe } from '../pipes/content/alphabet.pipe';
import { RestaurantPipe } from '../pipes/content/restaurant.pipe';
import { EventPipe } from '../pipes/content/event.pipe';
import { GalleryPipe } from '../pipes/content/gallery.pipe';
import { PersonPipe } from '../pipes/content/person.pipe';
import { CrossCountrySkiingPipe } from '../pipes/content/cross-country-skiing';
import { HikingPipe } from '../pipes/content/hiking';
import { GastroPipe } from '../pipes/content/gastro.pipe';
import { ActivityPipe } from '../pipes/content/activity.pipe';
import { CinemaPipe } from '../pipes/content/cinema.pipe';
import { OpeningHoursPipe } from '../pipes/content/opening-hours.pipe';
import { AccommodationPipe } from '../pipes/content/accommodation.pipe';
import { OpeningStatePipe } from '../pipes/content/opening-state.pipe';
import { AirportPipe } from '../pipes/content/airport.pipe';
import { SocialMediaPipe } from '../pipes/content/social-media.pipe';
import { ImportantNumbersPipe } from '../pipes/content/important-numbers.pipe';
import { StreetConditionsPipe } from '../pipes/content/street-conditions.pipe';
import { SocialMediaFeedPipe } from '../pipes/content/social-media-feed.pipe';
import { MountainRailwayNewPipe } from '../pipes/content/mountain-railway-new.pipe';
import { ManMadeWeatherPipe } from '../pipes/content/man-made-weather.pipe';
import { PublicTransportPipe } from "../pipes/content/public-transport.pipe";
import { PinboardPipe } from '../pipes/content/pinboard.pipe'

export const ContentPipesByContentType = new Map<string, any>([
  ['activity', ActivityPipe],
  ['alphabet', AlphabetPipe],
  ['bus', TransportPipe],
  ['cinema', CinemaPipe],
  ['cross-country-skiing', CrossCountrySkiingPipe],
  ['cross-country', CrossCountrySkiingPipe], // todo wrong content-type
  ['event', EventPipe],
  ['offer', RestaurantPipe],
  ['gallery', GalleryPipe],
  ['gastronomy', GastroPipe],
  ['hiking', HikingPipe],
  ['information', InformationPipe],
  ['memory', GalleryPipe],
  ['man-made-weather', ManMadeWeatherPipe],
  ['mountain-railway', MountainRailwayPipe],
  ['mountain-railway-new', MountainRailwayNewPipe],
  ['news', NewsPipe],
  ['person', PersonPipe],
  ['restaurant', RestaurantPipe],
  ['webcam', WebcamPipe],
  ['weather', WeatherPipe],
  ['temperature', TemperaturePipe],
  ['train', TransportPipe],
  ['opening-hours', OpeningHoursPipe],
  ['accommodation', AccommodationPipe],
  ['opening-state', OpeningStatePipe],
  ['airport', AirportPipe],
  ['social-media', SocialMediaPipe],
  ['social-media-feed', SocialMediaFeedPipe],
  ['important-numbers', ImportantNumbersPipe],
  ['street-conditions', StreetConditionsPipe],
  ['partner', RestaurantPipe],
  ['screensaver', GalleryPipe],
  ['public-transport', PublicTransportPipe],
  ['pinboard', PinboardPipe],
]);
